import store from '@/store'
import { getData } from '@core/utils/http/general'

// const buildParams = (action, extra = {}) => {
//   const params = { action, ...extra }
//   if (store.state.cuenta?.session?.token) {
//     params.token = store.state.cuenta.session.token
//   }
//   return params
// }

export const datoFacturaInfo = idDatof => new Promise((resolve, reject) => {
  // const ws = (store.state.cuenta.session.token) ? 'wsfactura' : 'wsinscripcion'
  const paramsRequest = {
    action: 23, // (!store.state.cuenta.session.token) ? 23 : 5,
    factura: idDatof,
    // token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsinscripcion')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

export const getPathxOrden = async orden => {
  try {
    const response = await getData({ action: 11, orden }, 'wsinscripcion')
    const { status, data } = response

    if (status !== 200 || data.status !== 200) {
      throw new Error(data?.message || 'Error al obtener el path por orden')
    }

    return data
  } catch (error) {
    throw error instanceof Error ? error : new Error('Error inesperado en getPathxOrden')
  }
}

export const cursoInfo = idCurso => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 4,
    curso: idCurso,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wscursos')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        const { curso, recursos, parciales } = response.data
        resolve({ curso, recursos, parciales })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
